import { CsiCapableResponse, CsiTrigger } from 'app/providers/csi/model/types';

export const getCsiTrigger = (response?: CsiCapableResponse | null): CsiTrigger | null => {
  if (!response?.csi) return null;

  return {
    endpoint: response.endpoint,
    businessKey: response.business_key,
    redirectUrl: response.page,
  };
};
